import { render, staticRenderFns } from "./briefcase.vue?vue&type=template&id=1bd01ee2&"
import script from "./briefcase.vue?vue&type=script&lang=js&"
export * from "./briefcase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports